




import { Component, Mixins, Prop } from "vue-property-decorator";
import { BackgroundView } from "../system";
import { DocumentsPrintViewMixin } from "./mixins";

@Component({
  components: {
    BackgroundView,
  },
})
export default class DocumentsPrintView extends Mixins(DocumentsPrintViewMixin) {
  @Prop()
  documentIds: number[];

  get documentCount(): number {
    return this.documentIds
      ? this.documentIds.length
      : 0;
  }

  async mounted(): Promise<void> {
    try {
      await this.start("既存文書を印刷します.(" + this.documentCount + "文書)");
      this.isProcessing = true;
      const count = await this.printDocuments(
        this.documentIds,
        this.$configuration.behavior.document.processor.executeIntervalMilliSeconds);
      if (this.documentIds.length <= count) { // 大きいことはないはずだが念の為.
        await this.finish("既存文書を印刷しました.(" + count + "文書)");
      } else if (0 < count) {
        await this.suspend("一部の既存文書は印刷できませんでした.(" + count + "文書成功/" + (this.documentCount - count) + "文書失敗)");
      } else {
        await this.fatal("既存文書印刷できませんでした.(" + this.documentCount + "文書)");
      }
    } catch (e) {
      await this.fatal(e.message, e);
    }
  }
}
